function* range(from: number, to: number, includeTo?: boolean) {
  for (let i = from; includeTo ? i <= to : i < to; i++) {
    yield i
  }
}

export default range
